document.addEventListener('DOMContentLoaded', function () {
    updateProgressBar();

    // Select all buttons with the 'data-add-to-cart' attribute
    const addToCartButtons = document.querySelectorAll('button[data-add-to-cart]');

    // Add a click event listener to each button
    addToCartButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            // Run the updateProgressBar function
            e.preventDefault();
            const $this = $(this);
            const productContainer = $this.closest('.tab-content');
            const productForm = productContainer.find('.product__form');
            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: productForm.serialize(),
                beforeSend: function beforeSend() {
                    $this.find('[data-add-to-cart-text]').text('Adding...');
                },
                success: function success(product) {
                    // avoid cart popup
                    var removeCartVisible = setInterval(function () {
                        if ($('#rebuy-cart.is-visible').length > 0) {
                            clearInterval(removeCartVisible);
                            Rebuy.SmartCart.hide();
                        }
                    }, 100);
                    // empty slot

                    // ATC button
                    $this.find('[data-add-to-cart-text]').text('Added!');

                    setTimeout(function () {
                        $this.find('[data-add-to-cart-text]').text('ADD ANOTHER');
                        $this.addClass('btn--border');
                        const prodContainer = $this.closest('.tab-content');
                        const itemNumber = parseInt(prodContainer.data('item-number')) + 1;
                        const nextTabLink = $('.tab-link-' + itemNumber);
                        nextTabLink.click();
                    }, 2000);

                    updateProgressBar();



                },
                error: function error(XMLHttpRequest) {
                    $this.html('SOLD OUT');
                    var response = eval('(' + XMLHttpRequest.responseText + ')');
                },
            });




        });
    });
});

// Assuming you have a function to get the current cart value
// This will depend on how your Shopify store is set up
function getCartValue(callback) {
    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function (cart) {

            callback(cart); // Call the callback function with the total price
        },
        error: function (xhr, status, error) {
            console.error('An error occurred fetching the cart:', error);
            callback(null); // Call the callback function with null in case of error
        }
    });
}

function updateProgressBar() {
    getCartValue(function (cart) {
        var shadowHost = $('cart-count')[0]; // Get the native DOM element
        var shadowRoot = shadowHost.shadowRoot;
        var $spanInsideShadowDOM = $(shadowRoot).find('span');
        var isB2b = $('[data-is-b2b]')[0].getAttribute('data-is-b2b');
        $spanInsideShadowDOM.text(cart.item_count);
        var cartValue = cart.original_total_price / 100;

        var cartValueWithoutFreeProduct = 0;

        for (item of cart.items) {
            if (item.handle != "throw-blanket" && item.discounted_price != 0) {
                var totalLinePrice = item.original_price * item.quantity;
                var totalLinePriceInDollars = totalLinePrice / 100;
                cartValueWithoutFreeProduct = cartValueWithoutFreeProduct + +totalLinePriceInDollars.toFixed(2);
            }
        }

        let progress = '0%';
        var count = 0;
        const icons = document.querySelectorAll('#progress-bar .cs-picture');

        // Reset all icons to the default color
        icons.forEach(icon => {
            if (count == 1) {
                icon.style.backgroundColor = '#92c6e48f'; // Original color
            }
            count++;
        });

        if (isB2b == 'true') {
            if (cartValue > 6501) {
                progress = '100%';
                icons[4].style.backgroundColor = '#003057'; // Black
                icons[3].style.backgroundColor = '#003057'; // Black
                icons[2].style.backgroundColor = '#003057'; // Black
                icons[1].style.backgroundColor = '#003057'; // Black
                icons[0].style.backgroundColor = '#003057'; // Black
            } else if (cartValue >= 4001) {
                progress = '70%';
                icons[3].style.backgroundColor = '#003057'; // Black
                icons[2].style.backgroundColor = '#003057'; // Black
                icons[1].style.backgroundColor = '#003057'; // Black
                icons[0].style.backgroundColor = '#003057'; // Black
            } else if (cartValue >= 2001) {
                progress = '50%';
                icons[2].style.backgroundColor = '#003057'; // Black
                icons[1].style.backgroundColor = '#003057'; // Black
                icons[0].style.backgroundColor = '#003057'; // Black
            } else if (cartValue >= 501) {
                progress = '30%';
                icons[1].style.backgroundColor = '#003057'; // Black
                icons[0].style.backgroundColor = '#003057'; // Black
            } else if (cartValue >= 150) {
                progress = '10%';
                icons[0].style.backgroundColor = '#003057'; // Black
            }
        } else {
            if (cartValue >= 400) {
                progress = '100%';
                icons[2].style.backgroundColor = '#003057'; // Black
                icons[1].style.backgroundColor = '#003057'; // Black
                icons[0].style.backgroundColor = '#003057'; // Black
            } else if (cartValue >= 300) {
                progress = '66%';
                icons[1].style.backgroundColor = '#003057'; // Black
                icons[0].style.backgroundColor = '#003057'; // Black
            } else if (cartValue >= 150) {
                progress = '33%';
                icons[0].style.backgroundColor = '#003057'; // Black
            } else {
                icons[2].style.backgroundColor = '#92c6e48f'; // Blue
                icons[1].style.backgroundColor = '#92c6e48f'; // Blue
                icons[0].style.backgroundColor = '#92c6e48f'; // Blue
            }
        }


        document.querySelector('#progress-bar .cs-progress').style.width = progress;
    });
}

document.addEventListener('rebuy:cart.add', (event) => {
    updateProgressBar();
});

document.addEventListener('rebuy:cart.change', (event) => {
    updateProgressBar();
});

